import { z } from 'zod'
import { TwoFactorMethod } from '../../models/TwoFactorMethod'
import type { TwoFactorStatus } from '../../models/TwoFactorStatus'

export const TwoFactorStatusDTO = z.object({
  enabled: z.boolean(),
  method: z.nativeEnum(TwoFactorMethod).nullable()
})

export type TwoFactorStatusDTO = z.infer<typeof TwoFactorStatusDTO>

export function mapDTOToTwoFactorStatus (dto: TwoFactorStatusDTO): TwoFactorStatus {
  return {
    enabled: dto.enabled,
    method: dto.method ?? undefined
  }
}

export function mapTwoFactorStatusToDTO (model: TwoFactorStatus): TwoFactorStatusDTO {
  return {
    enabled: model.enabled,
    method: model.method ?? null
  }
}
